import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AutenticacaoService } from '@app/services/autenticacao.service';
import { SisrhService } from '@app/services/sisrh.service';
import { Candidato } from '@app/models/sisrh.model';
import { AppUtil } from '@app/utils/app.util';
import { CamposValidator } from '@app/validators/campos.validator';
import { ModalService } from '@app/shared/services/modal.service';

@Component({
  templateUrl: './alteracao-senha.page.html'
})
export class AlteracaoSenhaPage implements OnInit {

  enviando = false;
  fgAlteracaoSenha: FormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private autenticacaoService: AutenticacaoService,
    private fb: FormBuilder,
    private modalService: ModalService,
    private sisrhService: SisrhService,
    private router: Router
  ) {

    if (!this.autenticacaoService.getValorUsuarioAtualCandidato.novaSenha) {
      this.router.navigate(['/vagas/lista']);
    }

  }

  ngOnInit() {

    AppUtil.focalizarCampo('idSenhaAntiga');

    this.fgAlteracaoSenha = this.fb.group({
      idCandidato: this.autenticacaoService.getValorUsuarioAtualCandidato.idCandidato,
      senhaAtual: ['', Validators.required],
      novaSenha: ['', Validators.required],
      novaSenhaConfirmacao: ['', Validators.required]
    },
      {
        validator: [
          CamposValidator.diferentes('senhaAtual', 'novaSenha'),
          CamposValidator.iguais('novaSenha', 'novaSenhaConfirmacao')
        ]
      }
    );

  }

  get c() {

    return this.fgAlteracaoSenha.controls;

  }

  alterar() {

    this.enviando = true;

    if (this.fgAlteracaoSenha.invalid) {
      return;
    }

    this.fgAlteracaoSenha.disable();

    this.sisrhService.alterarSenha(this.fgAlteracaoSenha.value)
      .subscribe(
        x => {
          if (x.success) {
            const candidato: Candidato = Object.assign({}, this.autenticacaoService.getValorUsuarioAtualCandidato);
            candidato.novaSenha = false;
            this.autenticacaoService.setValorUsuarioAtualCandidato(candidato,this.autenticacaoService.getTokenCandidato());
            const urlRetorno = this.activatedRoute.snapshot.queryParams.urlRetorno || '/vagas/lista';
            this.router.navigate([urlRetorno]);
          } else {
            x.data.forEach(y => {
              this.modalService.alert(
                'a',
                'Atenção',
                y.message
              ).subscribe(() => this.ok());
            });
          }
        },
        () => {
          this.modalService.alert(
            'e',
            'Erro',
            'Ocorreu um erro. Tente novamente mais tarde.'
          ).subscribe(() => this.ok());
        }
      );

  }

  ok() {

    this.fgAlteracaoSenha.enable();
    this.enviando = false;
    AppUtil.focalizarCampo('idSenhaAntiga');

  }

  cancelar() {

    this.autenticacaoService.logout();
    this.router.navigate(['/login']);

  }

}
